export default __webpack_public_path__ + "static/media/AutoVD2.b38ba0ce.png";